<template>
  <div>
    <div class="waner-msg">
      <p>{{ msg }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "WanerBubble",
  props: ["msg"],
};
</script>

<style lang="scss" scoped>
.waner-msg {
  position: absolute;
  width: max-content;
  height: max-content;
  bottom: 12vh;
  left: 5vw;
  background-image: url("../../assets/medias/images/speech-bubble.png");
  background-size: 100% 100%;
  color: $blue;
  z-index: 3;
  opacity: 0.9;
}

p {
  padding: 4vh;
  padding-bottom: 6vh;
  margin: 0;
  max-width: 33vw;
  font-size: 1.5vw;
}
</style>
